<template>
  
  <v-container fluid grid-list-lg>
    <v-layout row align-center>
      <v-flex class="text-xs-center">
        <h1>Your personalized suitcase is waiting!</h1>
      </v-flex>
    </v-layout>

    <v-layout row justify-center align-center>
      <v-flex shrink style="min-height: 38px;">
        <span class="red--text font-weight-bold" v-html="authError"></span>
      </v-flex>
    </v-layout>

    <v-layout row align-center wrap>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 class="text-xs-center">
        <v-btn flat outline @click="googleAuth"><v-icon class="mr-2">fab fa-google</v-icon> <span style="font-size: 1.3em;">GOOGLE</span></v-btn>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        OR
      </v-flex>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4>
        <div class="field-label">*Email</div>
        <v-text-field
          v-model="email"
          placeholder="Email"
          solo
          flat
          hide-details
          @input="clearError"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4>
        <div class="field-label">*Password</div>
        <v-text-field
          v-model="password"
          placeholder="Password"
          type="password"
          solo
          flat
          hide-details
          @input="clearError"
          @keyup="checkKeyup"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 class="text-xs-right">
        <span class="body-1"><router-link :to="{name: 'auth-forgot'}">Forgot Password?</router-link></span>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <v-btn :loading="loggingIn" color="primary" @click="login" style="min-width: 150px;">SIGN IN</v-btn>
      </v-flex>
    </v-layout>

    <!--<v-layout row my-2>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 class="text-xs-center" style="overflow: hidden;">
        <div class="strike-sides"><span class="px-2">Or continue with</span></div>
      </v-flex>
    </v-layout>

    <v-layout row justify-center>
      <v-flex shrink>
        <v-btn icon outline large><v-icon>fab fa-google</v-icon></v-btn>
      </v-flex>
      <v-flex shrink>
        <v-btn icon outline large><v-icon>fab fa-facebook-f</v-icon></v-btn>
      </v-flex>
      <v-flex shrink>
        <v-btn icon outline large><v-icon>fab fa-twitter</v-icon></v-btn>
      </v-flex>
    </v-layout>-->

    <v-layout row my-2>
      <v-flex xs12 class="text-xs-center">
        <span class="body-1"><router-link :to="{name: 'auth-register'}">Don't Have An Account? Join Now</router-link></span>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>

export default {
  name: 'Auth',
  data () {
    return {
      loggingIn: false,
      authError: null,

      email: null,
      password: null
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    }
  },
  methods: {
    login: function() {
      let ref = this;
      ref.loggingIn = true;

      this.$http
        .post('auth',{
          email: this.email,
          password: this.password
        })
        .then(response => {
          this.$store.commit('setOauthRedirect',null);
          this.$store.commit('setReferredBy', null);
          this.email = null;
          this.password = null;
          this.authError = null;
          this.$store.commit('updateAccessToken', response.data.access_token);
          delete(response.data.access_token);
          this.$store.commit('setUser', response.data);
          if(this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          } else {
            this.$router.push({name: 'account-trips'});
          }
          this.$store.dispatch('checkForUpdates');
        })
        .catch(error => {
          console.log(error);
          ref.authError = 'Incorrect Email or Password. Please try again.';
          this.loggingIn = false;
        });

    },
    clearError: function(e) {
      this.authError = null;
    },
    checkKeyup: function(e) {
      if(e.key == 'Enter') this.login();
    },

    googleAuth: function() {
      if(this.$route.query.redirect) {
        this.$store.commit('setOauthRedirect', this.$route.query.redirect);
        this.$router.replace({name: 'auth', params:[], query: []});
      }
      let queryParams = [
        'client_id=' + process.env.VUE_APP_GOOGLE_CLIENT_ID,
        'redirect_uri=' + process.env.VUE_APP_URL + 'auth/oauth/google',
        'response_type=code',
        'scope=email profile openid',
        'prompt=select_account'
      ]
      window.location = 'https://accounts.google.com/o/oauth2/v2/auth?' + queryParams.join('&');
    }
  }
}
</script>
<style lang="scss">
  .strike-sides {
    display: inline-block;
    position: relative;
    font-size: 1.2em;
  }
  .strike-sides:after,
  .strike-sides:before {
      content: "";
      position: absolute;
      height: 1px;
      width: 200%;
      top: 50%;
      right: 100%;
      background: rgba(0,0,0,.3);
  }
  .strike-sides:after { left: 100%; }
</style>